import { MateSolveStatus } from '../definition';

/**
 * 判断配合诊断是否需要错误提示；完整树和增量展示必须使用同一状态解释。
 * @param status 已提交配合的求解状态。
 * @param errorMessage 已提交诊断信息。
 * @returns 求解失败、引用/几何不可用或存在明确诊断信息时为 true。
 */
export function isAssemblyMateDiagnosticError(
  status: MateSolveStatus | undefined,
  errorMessage?: string,
): boolean {
  return (
    status === MateSolveStatus.Unsolved ||
    status === MateSolveStatus.OverDefined ||
    status === MateSolveStatus.MissingReference ||
    status === MateSolveStatus.UnsupportedGeometry ||
    Boolean(errorMessage)
  );
}
